import { Component, OnInit } from '@angular/core';
import { CargaAbonosService } from 'src/app/services/carga-abonos/carga-abonos.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import {FormsModule} from '@angular/forms';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export interface DialogData
{
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'app-carga-abonos',
  templateUrl: '../../pages/carga-abonos/carga-abonos.component.html',
  styleUrls: ['../../pages/carga-abonos/carga-abonos.component.css']
})
export class CargaAbonosComponent implements OnInit 
{
    rol:string = localStorage.getItem("rol")
    idUsuario:string =localStorage.getItem("idUsuario")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    
    cargaMasiva: any = { tipoCarga:null,  idUsuario:null, archivo: File = null, }
 
    agrupadorProductos: any = []
    currentDate: any
    botonActivo: any = true
    
    allComplete: boolean = false

    constructor(private CargaAbonosService: CargaAbonosService, private postulacionesService: PostulacionesService,
                private dialog: MatDialog) { }

    ngOnInit(): void 
    {
        let vm = this
        this.currentDate    = new Date(Date.now()).getTime();
      

        this.loadData()
    }

    loadData()
    {
        let vm = this
    }
    
   
    verArchivo(postulacionId: any)
    {
        let vm = this
    
        this.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`             
                    window.open(fileURL);
                })  
               
            }
        )
        .catch 
        ( 
            error =>  
            {
                console.log(error)

                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )        
    }
  

    csvInputChange(fileInputEvent: any) { 

        this.cargaMasiva.archivo = fileInputEvent.target.files[0] 
    }
  
    enviarPostulacionesSeleccionadas()
    {
        let vm = this
        this.botonActivo = false; 
        if(isNullOrUndefined(this.cargaMasiva.archivo) ||
        this.cargaMasiva.archivo?.type != ('text/csv'))
        {
            this.openAlertDialog('Debe seleccionar un archivo CSV.', 'btn-danger')
            this.botonActivo = true; 
            return
        }
        this.CargaAbonosService.creaCargaMasiva(this.cargaMasiva,this.idUsuario).then
        (
            () =>
            {
                vm.openAlertDialog('El proceso de carga abonos se está realizando, cuando finalice se le enviará un correo notificando.', 'btn-success')
                this.cargaMasiva.archivo =null;
                this.botonActivo = true; 
            }
        )
        .catch(error =>
        {
            console.log(error)

            vm.openAlertDialog('Ha ocurrido un error al procesar la carga', 'btn-danger')
            this.cargaMasiva.archivo =null;
            this.botonActivo = true; 
        })
    }


    openAlertDialog(mensaje: string, clase: string)  
    {
        const dialogRef = this.dialog.open(AlertDialogComponent, 
        {
            data: 
            {              
                message: mensaje,
                clase: clase,
                buttonText: { cancel: 'Listo!' },
            }
        })
    }

    pageChanged(event: any) 
    { 
        this.config.currentPage = event 
        
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
    }

   
}